import * as React from "react";
import PieChart from "@cloudscape-design/components/pie-chart";
import Box from "@cloudscape-design/components/box";
import { TyreTable } from "./data list tyre/data";

interface DataItem {
  title: string;
  percentage: number;
  value: number;
}

interface TemperatureItem {
  tyres: TyreTable[]; // Array of tyres with battery percentage
}

const Temperature: React.FC<TemperatureItem> = ({ tyres }) => {
  // Generate battery data from tyres
  const temperatureData = tyres.map((tyre) => ({
    id: tyre.id,
    temperature: tyre.temperature, 
 
    // Battery percentage
  }));
  console.log(temperatureData);
  // Function to categorize batteries
  const categorizeBatteries = (temperatures: { temperature: number }[]): DataItem[] => {
    const categoryCount = { OK: 0, Warning: 0, Attention: 0 };

    temperatures.forEach((_pressure) => {
      if (_pressure.temperature >= 75 && _pressure.temperature <= 85) {
        categoryCount.OK += 1;
      } else if (_pressure.temperature > 85) {
        categoryCount.Warning += 1;
      } else if (_pressure.temperature < 75) {
        categoryCount.Attention += 1;
      }
    });

    const total = temperatures.length;

    // Calculating percentages for each category
    return [
      {
        title: "OK",
        value: categoryCount.OK,
        percentage: (categoryCount.OK / total) * 100,
      },
      {
        title: "Hot",
        value: categoryCount.Warning,
        percentage: (categoryCount.Warning / total) * 100,
      },
      {
        title: "Cold",
        value: categoryCount.Attention,
        percentage: (categoryCount.Attention / total) * 100,
      },
    ];
  };

  // Process battery data to get categorized data for the pie chart     
  const pieChartData = categorizeBatteries(temperatureData);

  return (
    <div style={{ textAlign: "center" }}>
      <h3 style={{ marginTop: "0px" }}>Temperature Status</h3>
      <PieChart
        data={pieChartData}
        ariaDescription="Pie chart showing battery health statuses."
        ariaLabel="Battery Status Pie Chart"
        size="small"
        innerMetricDescription="Total Batteries"
        innerMetricValue={temperatureData.length.toString()}
        empty={
          <Box textAlign="center" color="inherit">
            <b>No data available</b>
            <Box variant="p" color="inherit">
              There is no data available
            </Box>
          </Box>
        }
        noMatch={
          <Box textAlign="center" color="inherit">
            <b>No matching data</b>
            <Box variant="p" color="inherit">
              There is no matching data to display
            </Box>
          </Box>
        }
      />
    </div>
  );
};

export default Temperature;